import { useEffect, useState } from "react";
import dayjs from "dayjs";
import moment from "moment";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextFieldDate from "../../UI/TextFieldDate";

/** Diálogo para registrar (ou alterar a data de) um dia de presença do integral. */
const IntegralPresencaForm = ({ integralPresenca, onClose, onSave, isSaving }) => {
  const [data, setData] = useState(null);
  const [alterada, setAlterada] = useState(false);

  useEffect(() => {
    if (!integralPresenca) return;
    // A data vem em UTC; usa o dia UTC para não exibir o dia anterior.
    setData(integralPresenca.data ? dayjs(moment.utc(integralPresenca.data).format("YYYY-MM-DD")) : dayjs());
    setAlterada(!integralPresenca.data);
  }, [integralPresenca]);

  const podeSalvar = data && dayjs(data).isValid() && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({ ...integralPresenca, data: alterada ? dayjs(data) : integralPresenca.data });
  };

  return (
    <Dialog open={Boolean(integralPresenca)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{integralPresenca?.codigo ? "Alterar Data" : "Registrar Dia"}</DialogTitle>
        <DialogContent>
          <TextFieldDate
            label="Data"
            value={data}
            onChange={(valor) => {
              setData(valor);
              setAlterada(true);
            }}
            slotProps={{ textField: { size: "small", fullWidth: true, required: true, margin: "dense" } }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default IntegralPresencaForm;
